import React from "react";
import { HeaderUserItem } from "codekit";
import { useGetSimulabDisponibleQuery } from "../../libs/redux/slices/Simulab/simulabApiSlice";

/**
 * Opción «Simulador del laboratorio» del menú del usuario. Solo aparece si el backend dice que el simulador existe en
 * el ambiente (fuera de producción); en producción la consulta responde 404 y la opción no se pinta. Abre la ruta
 * propia /laboratorio en otra pestaña para tener el panel al lado de CIMA.
 * @author Claude Code (Alexandra Parra) <direccionit.siaco@repremundo.com.co>
 * @since 2026-10-26
 */
const Simuenla = () => {
  const { data, isError } = useGetSimulabDisponibleQuery();
  if (isError || !data?.data?.DISPONIBLE) {
    return null;
  }
  return (
    <HeaderUserItem icon="config" onClick={() => window.open("/laboratorio", "_blank", "noopener")}>
      Simulador del laboratorio
    </HeaderUserItem>
  );
};

export default Simuenla;
